




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import Footer from '@/components/layout/Footer.vue';
import views from '@/views/Views';
import Warning from '@/components/layout/Warning.vue';

@Component({
  components: {
    Footer,
    Warning,
  },
})
export default class Home extends Vue {
  @Prop({ required: true })
  language!: string;

  @Prop({ required: true })
  displayWarning!: boolean;

  // eslint-disable-next-line global-require, import/no-dynamic-require
  text = require(`@/text_${this.language}.json`);

  // eslint-disable-next-line class-methods-use-this
  getItems(): { id: number; path: string; title: string;
   img: string; view: string; component: string; }[] {
    return views;
  }
}
